


















import { computed, defineComponent, PropType } from '@vue/composition-api';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import { useMemberConditions } from '@front-app/modules/groupMember/hooks/useMemberConditions';

export default defineComponent({
	components: { ErrorCard },
	props: {
		groupId: {
			type: String,
			required: true,
		},
		selectedRole: {
			type: String as PropType<UserRole>,
			required: true,
		},
	},
	setup(props) {
		const {
			currentNumMembers,
			currentNumMembersForRole,
			hasReachedMaxMembers,
			hasReachedMaxForRole,
		} = useMemberConditions(computed(() => props.groupId), computed(() => props.selectedRole));

		return {
			UserRole,
			currentNumMembers,
			currentNumMembersForRole,
			hasReachedMaxMembers,
			hasReachedMaxForRole,
		};
	},
});
